module.exports = __webpack_public_path__ + "img/unipi-logo.f0cb2a25.svg";